import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: ""})
export class FlaggedTopicListConfig {

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/FlaggedTopicListConfig.ts